export default "__VITE_PUBLIC_ASSET__4dd541ac__"